import React from "react";
import { Typography, Button } from "@mui/material";
import CommonModal from "../../../modal/CommonModal";
import { pageLocale } from "../../../../utils/locale";
import "./riskdefinitionmodal.scss";

const RiskDefinitionModal = ({
  open,
  onClose,
  type,
  categoryKey,
  metricName,
}) => {
  const mv2 = pageLocale("metricsv2");
  const mv2Categories = pageLocale("metricsv2_categories");
  const riskModal = pageLocale("riskModal");

  const getDefinitionContent = () => {
    if (type === "overall") {
      return {
        title: riskModal?.overall_title,
        content: (
          <>
            {riskModal?.overall_content_prefix}
            <strong>{riskModal?.overall_content_lowest}</strong>
            {riskModal?.overall_content_suffix}
            <ol>
              <li>{riskModal?.overall_item_1}</li>
              <li>{riskModal?.overall_item_2}</li>
            </ol>
          </>
        ),
      };
    } else if (type === "category") {
      const categoryDefinitionKey = categoryKey
        ? `category_${categoryKey}`
        : null;
      const categoryLabel = categoryKey
        ? mv2Categories?.[categoryKey]
        : metricName;

      return {
        title: `${categoryLabel || ""}${
          riskModal?.category_risk_title_suffix || ""
        }`,
        content: (
          <p>
            {(categoryDefinitionKey && riskModal?.[categoryDefinitionKey]) ||
              riskModal?.category_risk_fallback}
          </p>
        ),
      };
    } else if (type === "metric") {
      return {
        content: <p>{riskModal?.metric_threshold_desc}</p>,
      };
    }

    return {
      content: <p>{riskModal?.default_desc}</p>,
    };
  };

  const { content } = getDefinitionContent();

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      className="risk-definition-modal"
    >
      <div className="risk-definition-content">
        <div className="risk-definition-body">
          <Typography className="risk-definition-text">{content}</Typography>
        </div>
        <div className="risk-definition-footer">
          <Button
            variant="contained"
            className="risk-definition-close-btn"
            onClick={onClose}
          >
            {mv2?.close}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default RiskDefinitionModal;
